import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TrainingService } from '../../training/training.service';
import { EmployeeTraining, TrainingStatus } from '../../training/training';

import { PolicyService } from '../../policy/policy.service';
import { EmployeePolicy } from '../../policy/policy';

declare var $: any;

@Component({
    selector: 'eup-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    standalone: false,
})
export class DashboardComponent implements OnInit {
    #trainingService = inject(TrainingService);
    #policyService = inject(PolicyService);
    #router = inject(Router);

    trainings: EmployeeTraining[];
    policies: EmployeePolicy[];

    ngOnInit(): void {
        $('body .modals').remove();

        this.#trainingService.getEmployeeTrainings().subscribe({
            next: (trainings) => (this.trainings = trainings),
            error: (err) => console.log(err),
        });
        this.#policyService.getEmployeePolicies().subscribe({
            next: (policies) => (this.policies = policies),
            error: (err) => console.log(err),
        });
    }

    selectedTraining: EmployeeTraining;
    goTraining(t: EmployeeTraining) {
        if (t.status != TrainingStatus.expired && t.status != TrainingStatus.complete) {
            this.selectedTraining = t;
            if (!t.disabled) {
                this.#router.navigateByUrl('/training/' + t.siteTrainingId);
            } else {
                $('.ui.modal.training-alert').modal('show');
            }
        }
    }

    selectedPolicy: EmployeePolicy;
    showPolicy(p: EmployeePolicy) {
        this.selectedPolicy = p;
        $('.ui.modal.policy-dialog').modal('show');
    }

    acceptPolicy() {
        this.#policyService.accept(this.selectedPolicy.sitePolicyId).subscribe({
            next: () => {
                this.#policyService.getEmployeePolicies().subscribe({
                    next: (policies) => (this.policies = policies),
                    error: (err) => console.log(err),
                });
            },
            error: (err) => console.log(err),
        });
        $('.ui.modal.policy-dialog').modal('hide');
    }
    rejectPolicy() {
        this.#policyService.reject(this.selectedPolicy.sitePolicyId).subscribe({
            next: () => {
                this.#policyService.getEmployeePolicies().subscribe({
                    next: (policies) => (this.policies = policies),
                    error: (err) => console.log(err),
                });
            },
            error: (err) => console.log(err),
        });
        $('.ui.modal.policy-dialog').modal('hide');
    }

    closePolicy() {
        $('.ui.modal.policy-dialog').modal('hide');
    }

    closeTrainingAlert() {
        $('.ui.modal.training-alert').modal('hide');
    }
}
